/**
 * Shown when phone stats "All" load is capped for browser stability.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Info } from 'lucide-react';

interface PhoneStatsDatasetLimitBannerProps {
  maxLoaded: number;
  totalMatching: number;
}

export const PhoneStatsDatasetLimitBanner: FC<PhoneStatsDatasetLimitBannerProps> = ({
  maxLoaded,
  totalMatching,
}) => (
  <div
    role="status"
    className="flex gap-2 rounded-md border border-border bg-muted/50 px-3 py-2.5 text-sm text-foreground"
  >
    <Info className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
    <p className="min-w-0 leading-snug text-muted-foreground">
      <span className="font-medium text-foreground">Display limit applied.</span>{' '}
      To keep this page fast and stable, the <strong>All</strong> option loads at most{' '}
      {maxLoaded.toLocaleString()} rows per request. Your current range matches{' '}
      {totalMatching.toLocaleString()} rows—narrow the date range or use filters to focus results, or
      use <strong>Download CSV</strong> when you need a broader extract.
    </p>
  </div>
);
